__turbopack_context__.v({
  "error-msg": "label-module-scss-module__nUFdna__error-msg",
  "errorIcon": "label-module-scss-module__nUFdna__errorIcon",
  "hint": "label-module-scss-module__nUFdna__hint",
  "label": "label-module-scss-module__nUFdna__label",
  "optional": "label-module-scss-module__nUFdna__optional",
  "required": "label-module-scss-module__nUFdna__required",
});
